<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width" style="calc(100% - 300px)">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Новая акция</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" :loading="loading" :disabled="loading" @click="sendForm" class="v-btn--save">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Тайтл</v-subheader>
                    <v-text-field
                        ref="name"
                        v-model="sC.name"
                        v-validate="'required'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        single-line
                        text
                        solo
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Короткое описание</v-subheader>
                            <v-textarea
                                ref="sC_description"
                                v-model="sC.description"
                                v-validate="'required|max:140'"
                                data-vv-name="description"
                                :error-messages="errors.collect('description')"
                                text
                                solo
                                single-line
                                required
                                counter="140"/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="sC.status ? 'Включен' : 'Отключен'" v-model="sC.status" class="mt-0"/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <upload-img :image-width="1024" :image-height="1024" v-model="sC.img" :content-area="12"
                                        style="max-width: 253px;">
                                <div slot="activator">
                                    <v-avatar size="100%" v-ripple class="grey lighten-3" tile v-if="!sC.img">
                                        <img src="/static/img/media/image_blank.svg"
                                             alt="Нажмите чтобы добавить картинку для акции"/>
                                    </v-avatar>
                                    <v-avatar size="100%" v-ripple tile v-else>
                                        <img :src="sC.img.imageURL" alt="Изображение для акции"/>
                                    </v-avatar>
                                </div>
                            </upload-img>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Выберите тип скидки</v-subheader>
                            <v-select
                                :items="types"
                                item-value="key"
                                item-text="value"
                                v-model="sC.stock_type"
                                text
                                solo/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Количество скидки</v-subheader>
                            <v-text-field
                                ref="stockCount"
                                mask="######"
                                v-model="sC.stock_value"
                                v-validate="'required|min_value:1'"
                                data-vv-name="stock_value"
                                :error-messages="errors.collect('stock_value')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Выберите тип товаров</v-subheader>
                            <v-select
                                :items="target"
                                item-value="key"
                                item-text="value"
                                v-model="sC.target"
                                @change="targetSelect"
                                text
                                solo/>
                        </v-flex>
                        <v-spacer/>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0" v-if="sC.target > 0">Выберите Категории\Товары акции</v-subheader>
                    <v-select
                        v-if="sC.target === 1"
                        v-model="sC.categories"
                        :items="categories"
                        item-value="id"
                        item-text="name"
                        attach
                        chips
                        text
                        solo
                        deletable-chips
                        label="Категории"
                        multiple/>
                    <v-select
                        v-if="sC.target === 2"
                        v-model="sC.products"
                        :items="products"
                        item-value="id"
                        item-text="name"
                        attach
                        chips
                        text
                        solo
                        deletable-chips
                        label="Продукты"
                        multiple/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Дата начало</v-subheader>
                            <v-menu
                                ref="startMenu"
                                v-if="!dateUnlim"
                                v-model="startMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <template slot="activator">
                                    <v-text-field
                                        v-model="sC.start_date"
                                        prepend-icon="event"
                                        readonly
                                        text
                                        solo/>
                                </template>
                                <v-date-picker
                                    ref="startPicker"
                                    locale="ru-ru"
                                    first-day-of-week="1"
                                    v-model="sC.start_date"
                                    :min="new Date().toISOString().substr(0, 10)"
                                    @change="saveStartMenu"/>
                            </v-menu>
                            <v-checkbox v-model="dateUnlim" label="Срок не установлен"/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Дата окончания</v-subheader>
                            <v-menu
                                ref="endMenu"
                                v-if="!dateUnlim"
                                v-model="endMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <template slot="activator">
                                    <v-text-field
                                        v-model="sC.end_date"
                                        prepend-icon="event"
                                        readonly
                                        text
                                        solo/>
                                </template>
                                <v-date-picker
                                    ref="endPicker"
                                    locale="ru-ru"
                                    first-day-of-week="1"
                                    v-model="sC.end_date"
                                    :min="new Date(tomorrow).toISOString().substr(0, 10)"
                                    @change="saveEndMenu"/>
                            </v-menu>
                            <v-checkbox disabled label="Срок не установлен" v-model="dateUnlimCopy" v-show="dateUnlim"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Основной Текст</v-subheader>
                    <wysiwyg v-model="sC.text"/>
                </v-flex>
            </v-form>
            <v-dialog v-model="showDialog" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение</h4>
                    </v-card-title>
                    <v-card-text>
                        При создании акции, у всех акций данного типа статус поменятся на неактивный <br/> Вы уверены
                        что хотите этого?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitCreate">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="info" class="v-btn--save" @click="createStock">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="showDialog = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
    import UploadImg from '../../../../components/Media/Upload'
    import StockCatalog from '../../../../api/stockcatalog'
    import Category from '../../../../api/category'
    import Product from '../../../../api/product'

    export default {
        name: 'AddStockCatalog',
        components: { UploadImg },
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            startMenu: false,
            endMenu: false,
            dateUnlim: false,
            dateUnlimCopy: true,
            tomorrow: new Date(),
            types: [
                {
                    key: 1,
                    value: 'Процентная'
                },
                {
                    key: 2,
                    value: 'Конкретная сумма'
                },
            ],
            target: [
                {
                    key: 1,
                    value: 'Категории'
                },
                {
                    key: 2,
                    value: 'Продукты'
                }
            ],
            categories: [],
            products: [],
            sC: {
                name: '',
                description: '',
                stock_type: 1,
                text: '',
                img: '',
                status: true,
                target: 0,
                stock_value: null,
                categories: null,
                products: null,
                start_date: null,
                end_date: null,
            },
            showDialog: false,
            waitCreate: false,
            dictionary: {
                custom: {
                    name: {
                        required: 'Название не введено'
                    },
                    description: {
                        required: 'Короткое описание не введено',
                        max: 'Превышено максимальное количество символов в описании'
                    },
                    stock_value: {
                        min_value: 'Скидка не может быть равно нулью'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
        },
        methods: {
            saveStartMenu (date) {
                this.sC.end_date = null
                this.tomorrow = new Date(date)
                this.tomorrow.setDate(this.tomorrow.getDate() + 1)
                this.$refs.startMenu.save(date)
            },
            saveEndMenu (date) {
                if (!this.sC.start_date) {
                    this.sC.end_date = null

                    return
                }

                this.$refs.endMenu.save(date)
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        if (this.sC.target === 0) {
                            this.$store.commit('showSnackbar', { text: 'Выберите тип продуктов' })

                            return
                        }

                        if (!this.sC.categories && !this.sC.products) {
                            this.$store.commit('showSnackbar', { text: 'Выберите Категорию/Товары для акции' })

                            return
                        }

                        if (this.dateUnlim) {
                            this.sC.start_date = null
                            this.sC.end_date = null
                        }

                        if (!this.dateUnlim && !this.sC.start_date && !this.sC.end_date) {
                            this.$store.commit('showSnackbar', { text: 'Выберите дату' })

                            return
                        }

                        if (!this.sC.text) {
                            this.$store.commit('showSnackbar', { text: 'Основной текст не заполнен' })

                            return
                        }

                        if (!this.sC.img) {
                            this.$store.commit('showSnackbar', { text: 'Изображение обязательно для заполнение' })

                            return
                        }

                        this.loading = true
                        this.showDialog = true
                    })
                    .catch(error => new Error(error))
            },
            createStock () {
                this.waitCreate = true

                StockCatalog
                    .create(this.sC)
                    .then(response => {
                        this.$store.commit('storeStockCatalog', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Успех! Акция создано',
                            color: 'success'
                        })
                        this.$router.push({ name: 'stockCatalog' })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                    .finally(() => this.loading = false)
            },
            targetSelect (value) {
                value === 1 ? this.getCategory() : this.getProducts()
            },
            getCategory () {
                this.products = []
                this.sC.products = null

                Category
                    .getAll()
                    .then(response => {
                        response.data.data.map(item => {
                            this.categories.push({
                                id: item.id,
                                name: item.name
                            })
                        })
                    })
                    .catch(error => new Error(error))
            },
            getProducts () {
                this.categories = []
                this.sC.categories = null

                Product
                    .getAll()
                    .then(response => {
                        response.data.data.map(item => {
                            this.products.push({
                                id: item.id,
                                name: item.name
                            })
                        })
                    })
                    .catch(error => new Error(error))
            }
        }
    }
</script>
